import { useDispatch } from 'react-redux';
import { useLazyQuery } from '@apollo/client';
import { fetchExperimentTypes as fetchExperimentTypesQuery } from 'api/queries/experiments';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import { ExperimentType } from 'modules/graphql';

const source = 'useExperimentTypes';

export const useExperimentTypes = (campaignId: number) => {
  const { t } = useExperimentsTranslations();
  const dispatch = useDispatch();
  const [
    fetchExperimentTypes,
    {
      loading,
      data: { getExperimentTypes = {} } = {},
      error,
    },
  ] = useLazyQuery(fetchExperimentTypesQuery, {
    fetchPolicy: 'no-cache',
    variables: { campaignId },
  });
  const errorToasterMessage = t('errorMessage.fetchExperimentTypes');
  const errorMessage = `Failed to fetch experiment types for campaign id ${campaignId}`;

  if (error) {
    dispatch(
      addNegativeToast(
        errorToasterMessage,
        errorIdentifier({
          errorMessage,
          source,
          error,
        }),
      ),
    );
  }

  return {
    fetchExperimentTypes,
    experimentTypes: getExperimentTypes?.allowedTypes as ExperimentType[],
    isLoading: loading,
    isError: !!error,
  };
};
